import { BookOpen, Globe, ShoppingCart } from "lucide-react";
import { Btn, Eyebrow, PageHero } from "@/components/site/bits";
import { Reveal } from "@/components/site/Reveal";
import { BOOK, BOOK_URL, IMAGES } from "@/data/site";

export default function BookPage() {
    return (
        <main>
            <PageHero
                testid="book-hero"
                eyebrow="The Book"
                title="Breaking the Chains"
                sub="A Neuro-Bio-Spiritual Path to Freedom"
                image={IMAGES.bookBg}
            />
            <section className="relative overflow-hidden bg-[#08162A]">
                <img src={IMAGES.bookBg} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#08162A]/60 to-[#08162A]" />
                <div className="relative mx-auto grid max-w-6xl items-center gap-14 px-6 py-20 sm:py-24 lg:grid-cols-[auto_1.5fr]">
                    <Reveal className="flex justify-center">
                        <div className="relative">
                            <div className="absolute -inset-8 rounded-full bg-[#C9A227]/15 blur-3xl" />
                            <img
                                src={BOOK.cover}
                                alt="Breaking the Chains — A Neuro-Bio-Spiritual Path to Freedom, book cover"
                                data-testid="book-page-cover"
                                className="relative w-60 rounded-md shadow-[0_40px_80px_-25px_rgba(0,0,0,0.8)] transition-transform duration-500 hover:-translate-y-2 sm:w-72"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <Eyebrow light>By Dr. Sergio G. Jaquez</Eyebrow>
                        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white">
                            {BOOK.title}: {BOOK.subtitle}
                        </h2>
                        <div className="mt-6 space-y-4 text-base leading-relaxed text-white/85" data-testid="book-description">
                            <p>
                                Addiction is rarely just about the substance or the behavior. It is a cycle — wired
                                into the brain, rehearsed in our habits, and heavy on the soul. <em>Breaking the
                                Chains</em> is a Neuro-Clinical-Spiritual framework for breaking addictive cycles and
                                restoring the power of choice.
                            </p>
                            <p>
                                In these pages, Dr. Sergio Jaquez walks you through the anatomy of addiction and
                                relapse, the influence of the subconscious mind, and the spiritual foundations that
                                make lasting change possible. Whether you are facing addiction yourself, supporting
                                someone you love, or serving in recovery ministry, this book offers understanding —
                                and a path forward.
                            </p>
                        </div>
                        <div className="mt-6 flex flex-wrap gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-white/70">
                            <span className="flex items-center gap-2 rounded-full border border-[#C9A227]/40 px-4 py-2">
                                <BookOpen className="h-3.5 w-3.5 text-[#D4AF37]" /> Paperback
                            </span>
                            <span className="flex items-center gap-2 rounded-full border border-[#C9A227]/40 px-4 py-2">
                                <Globe className="h-3.5 w-3.5 text-[#D4AF37]" /> English
                            </span>
                        </div>
                        <div className="mt-8">
                            <Btn testid="book-buy-now-btn" href={BOOK_URL} cart className="px-8 py-4 text-base sm:text-lg">
                                Buy Now
                            </Btn>
                            <p className="mt-3 flex items-center gap-2 text-xs text-white/60">
                                <ShoppingCart className="h-3.5 w-3.5" /> Opens the official store in a new tab.
                            </p>
                        </div>
                    </Reveal>
                </div>
            </section>
        </main>
    );
}
